exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-table-wrapper{background-color:#fff!important}.patient-info{text-align:center;margin-top:20px;margin-bottom:20px}.patient-info img{margin-bottom:5px;width:100px;height:100px;border-radius:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/MedicationList/Medication.scss
// module id = 589
// module chunks = 0